export default "__VITE_ASSET__auFDA5KG__"